// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import animated from 'animate.css'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.prototype.$axios = axios;
// import Swiper from 'swiper'
// import 'swiper/dist/css/swiper.min.css';
// import AmazeVue from 'amaze-vue';
// import 'amaze-vue/dist/amaze-vue.css';

Vue.use(VueI18n) // 通过插件的形式挂载

// const i18n = new VueI18n({
//   locale: 'zh-CN', // 语言标识
//   messages: {
//     'zh-CN': require('./common/lang/zh'), // 中文语言包
//     'en-US': require('./common/lang/en') // 英文语言包
//   }
// })

Vue.config.productionTip = false;
//静态域名地址
Vue.prototype.$baseUrl = "http://demo.ztwjzy.com/xccm/superiorPay";

/* eslint-disable no-new */
// Vue.use(AmazeVue);
Vue.use(animated)
// Vue.use(Swiper)

// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })
new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
